export class GPTypeSnippet {
    constructor(gst) {

        this.typeName = "GPTypeSnippet"
        this.id = parseInt(gst["id"]);
        this.name = gst["name"];
        this.private = gst["private"];
        this.own = !!gst["own"];
        this.thumbUrl = gst["thumbUrl"];
        this.reference = gst["reference"];
        this.plants = gst["plants"];
        this.enabled = true;
        this.height = 0;

        let maxY = 0;
        let maxX = 0;
        let minX = 99999999;
        this.plants.forEach(plant => {
            if (plant.itemInstance.y > maxY) maxY = plant.itemInstance.y;
            if (plant.itemInstance.x > maxX) maxX = plant.itemInstance.x;
            if (plant.itemInstance.x < minX) minX = plant.itemInstance.x;
            if (!GP.plantTypesById[plant.itemInstance.typeId].enabled)
                this.enabled = false;
            if (GP.plantTypesById[plant.itemInstance.typeId].height > this.height)
                this.height = GP.plantTypesById[plant.itemInstance.typeId].height;
        })
        this.y = maxY;
        this.x = (maxX + minX) / 2;

    }

}